var scope_0 = require('/home/runner/work/armeria/armeria/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0271a8a851ccfc1bc236a33d127e0914.js').default;
var scope_1 = require('/home/runner/work/armeria/armeria/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0d94c5e7a8303b6023c5b81e18f536e5.js').default;
var scope_2 = require('/home/runner/work/armeria/armeria/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/14d61b650eba4c1810b97b90d805e715.js').default;
var scope_3 = require('/home/runner/work/armeria/armeria/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5f5a178695dc1412a4db8f5874d81eeb.js').default;
var scope_4 = require('/home/runner/work/armeria/armeria/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_5 = require('/home/runner/work/armeria/armeria/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee57db0b97f2c0ac981f4acdb67bbe1f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    